export default {
    // Common
    'Common.sort': 'Zoradiť',

    // Time
    'Time.from': 'Od',
    'Time.to': 'Do',
    'Time.setToNow': 'Nastaviť od teraz',

    // Table
    'Table.rowsPerPage': 'Počet riadkov',
    'Table.of': 'z',

    // General
    'General.console': 'Konzola',
    'General.logIn': 'Prihlásiť',
    'General.logInTitle': 'Prihlásenie sa',
    'General.username': 'Používateľské meno',
    'General.username.placeholder': 'Zadajte vaše prihlasovacie meno',
    'General.password': 'Heslo',
    'General.confirm.password': 'Potvrďte heslo',
    'General.password.placeholder': 'Zadajte vaše heslo',
    'General.application': 'Priestor',
    'General.application.placeholder': 'Zvoľte požadovaný priestor',
    'General.guides': 'Sprievodcovia',
    'General.guides.placeholder': 'Zvoľte požadovaných sprievodcov',
    'General.createApplication': 'Vytvoriť priestor',
    'General.domain': 'Doména',
    'General.domains': 'Domény',
    'General.organizations': 'Organizácia',
    'General.name': 'Názov',
    'General.firstName': 'Meno',
    'General.lastName': 'Priezvisko',
    'General.email': 'Email',
    'General.actions': 'Akcie',
    'General.language.english': 'Angličtina',
    'General.language.slovak': 'Slovenčina',
    'General.search.placeholder': 'Vyhľadávanie priestorov',
    'General.identifier': 'Identifikátor',
    'General.confirm': 'Potvrdiť',

    // Notifications
    'Notification.script.copied': 'Aplikačný skript bol skopírovaný',
    'Notification.configuration.copied': 'Konfigurácia bola skopírovaná',
    'Notification.save': 'Vaše nastavenia boli uložené',
    'Notification.apply': 'Vaše nastavenia boli použité',
    'Notification.fail': 'Nepodarilo sa uložiť Vaše dáta, niečo sa pokazilo',
    'Notification.fail.loadData': 'Nepodarilo sa načítať dáta, niečo sa pokazilo',
    'Notification.register.user.success': 'Registrácia užívateľa bola úspešná',
    'Notification.register.user.error': 'Registrácia používateľa nebola úspešná',
    'Notification.invite.user': 'Pozvanie používateľa bolo úspešné',
    'Notification.guides.update.success': 'Sprievodca bol úspešne aktualizovaný',
    'Notification.guides.update.fail': 'Nepodarilo sa aktualizovať sprievodcu',
    'Notification.guidesRules.update.success': 'Pravidlá sprievodcu boli úspešne aktualizované',
    'Notification.guidesRules.update.fail': 'Je nám ľúto, ale nemôžeme aktualizovať pravidlá sprievodcu',
    'Notification.guides.updateHost.success': 'Sprievodca bol publikovný',
    'Notification.guides.updateHost.fail': 'Nepodarilo sa publikovať sprievodcu',
    'Notification.domain.unique': 'Vaša doména nie je unikátna',
    'Notification.create.segment': 'Váš segment bol vytvorený',
    'Notification.edit.segment': 'Segment bol úspešne upraveý',
    'Notification.create.guide': 'Váš sprievodca bol vytvorený',
    'Notification.import.success': 'Váš import bol úspešný',
    'Notification.import.fail': 'Váš import nebol úspešný, niečo nie je v poriadku',
    'Notification.export.success': 'Váš export bol úspešný',
    'Notification.export.fail': 'Váš export nebol úspešný, niečo nie je v poriadku',
    'Notification.create.journey.success': 'Vaša trasa bola vytvorená',
    'Notification.create.journey.fail': 'Nepodarilo sa vytvoriť Vašu trasu, niečo sa pokazilo',
    'Notification.update.journey.success': 'Vaša trasa bola aktualizovaná',
    'Notification.update.journey.fail': 'Nepodarilo sa aktualizovať Vašu trasu, niečo sa pokazilo',
    'Notification.delete.journey.success': 'Vaša trasa bola vymazaná',
    'Notification.delete.journey.fail': 'Vaša trasa nebola odstránená, niečo nie je v poriadku',
    'Notification.create.addOn.success': 'Váš doplnok bol pridaný',
    'Notification.create.addOn.fail': 'Váš doplnok nebol pridaný, nie je v poriadku',
    'Notification.generation.guide.success':
        'Požiadavka na generovanie sprievodcov prijatá, vráťte sa neskôr do sprievodcov priestoru',
    'Notification.generation.guide.fail': 'Generovanie sprievodcov zlyhalo',
    'Notification.audience.resetAllFacts.success': 'Všetky fakty boli obnovené',
    'Notification.audience.resetAllFacts.fail': 'Nebolo možné obnoviť fakty',
    'Notification.generate.recording.success':
        'Generovanie Vášho dokumentu bolo úspešné. Obnovte svoju stránku, prosím',
    'Notification.generate.recording.fail': 'Generovanie dokumentu zlyhalo',
    'Notification.download.recording.success': 'Stiahnutie dokumentu bolo úspešné',
    'Notification.download.recording.fail': 'Stiahnutie dokumentu zlyhalo ',
    'Notification.duplicate.application.success':
        'Váš priestor bol úspešne duplikovaný. Prosím prejdite si sekciu priestorov',
    'Notification.duplicate.application.fail': 'Váš priestor nebol duplikovaný, niečo nie je v poriadku',
    'Notification.remove.user':
        'Tento používateľ je vlastníkom tohto priestoru, preto ho nemožno odstrániť',
    'Notification.report.notConfigured':
        'Nie je priradený žiadny analytický prehľad - pre viac informácií kontaktujte Vášho správcu',
    'Notification.theme.clone.success': 'Vaša téma bola naklonovaná',
    'Notification.theme.edit.success': 'Zmeny Vašej témy boli uložené',
    'Notification.theme.delete.success': 'Vaša téma bola zmazaná',

    // Filter
    'Filter.filters': 'Filtre',
    'Filter.configureFilter': 'Nakonfigurujte filter',
    'Filter.saveFilter': 'Ulož filter',
    'Filter.activeFilters': 'Aktívne kritériá',
    'Filter.segments': 'Segmenty',
    'Filter.country': 'Vyberte atribút',
    'Filter.country.chip': 'Krajina',
    'Filter.segments.country': 'Názov krajiny',
    'Filter.guide.features': 'Funkcie sprievodcu',
    'Filter.guide.features.startedFromContextHelp': 'Iba tie, ktoré sa začali z pomocníka',
    'Filter.guide.features.chip.label': 'Začaté z pomocníka',
    'Filter.guides': 'Sprievodcovia',
    'Filter.guides.guideName': 'Napíšte meno sprevodcu',
    'Filter.guidesHistory': 'Porovnaj históriu sprievodcov', // @TBD
    'Filter.guidesHistory.filterSubtitle': 'Vyberte historické obdobie', // @TBD
    'Filter.guidesHistory.filterSubtitle2': 'Vyberte sprievodcov na porovnanie', // @TBD
    'Filter.guidesFromHistory': 'Sprievodcovia z histórie',
    'Filter.timeRange.quick.tab': 'Rýchle',
    'Filter.timeRange.relative.tab': 'Relatívne',
    'Filter.timeRange.absolute.tab': 'Absolútne',
    'Filter.timeRange.quick.today': 'Dnes',
    'Filter.timeRange.quick.thisWeek': 'Tento týždeň',
    'Filter.timeRange.quick.thisMonth': 'Tento mesiac',
    'Filter.timeRange.quick.thisYear': 'Tento rok',
    'Filter.timeRange.quick.lastHour': 'Poslednú 1 hodinu',
    'Filter.timeRange.quick.last4Hours': 'Posledné 4 hodiny',
    'Filter.timeRange.quick.last12Hours': 'Posledných 12 hodín',
    'Filter.timeRange.quick.last24Hours': 'Posledných 24 hodín',
    'Filter.timeRange.quick.last7Days': 'Posledných 7 dní',
    'Filter.timeRange.quick.last30Days': 'Posledných 30 dní',
    'Filter.timeRange.quick.last60Days': 'Posledných 60 dní',
    'Filter.timeRange.quick.last90Days': 'Posledných 90 dní',
    'Filter.timeRange': 'Časový rozsah',
    'Filter.aBguides': 'A/B Sprievodcovia',
    'Filter.aBguides.aGuidePlaceholder': 'Meno prievodcu A',
    'Filter.aBguides.bGuidePlaceholder': 'Meno sprievodcu B',
    'Filter.aBguides.comparisionLabel': 'Označenie porovnania',
    'Filter.aBguides.vs': 'vs',
    'Filter.sampling': 'Výber vzoru',
    'Filter.timestampRanges': 'Rozsahy času',
    'Filter.timestamptRanges.key': 'Kľúč',
    'Filter.timestamptRanges.gte': 'Od dátumu',
    'Filter.timestamptRanges.lte': 'Do dátumu',
    'Filter.urls': 'Urls',
    'Filter.urls.urlName': 'Vyberte si url',
    'Filter.relativesElements': 'Elementy',

    // Buttons
    'Buttons.cancel': 'Zrušiť',
    'Buttons.save': 'Uložiť',
    'Buttons.createNewApp': 'Vytvoriť priestor',
    'Buttons.create': 'Vytvoriť',
    'Buttons.open&install': 'Otvoriť & inštalovať',
    'Buttons.copyScript': 'Kopírovať script',
    'Buttons.copyConfiguration': 'Kopírovanie konfigurácie',
    'Buttons.add': 'Pridať',
    'Buttons.apply': 'Použiť',
    'Buttons.import': 'Import',
    'Buttons.export': 'Export',
    'Buttons.switchActive': 'Aktívny',
    'Buttons.delete': 'Vymazať',
    'Buttons.perform': 'Vykonať',
    'Buttons.switchEnable': 'Aktivovať',
    'Buttons.filter': 'Filtrovať',
    'Buttons.registerUser': 'Registrovať používateľa',
    'Buttons.switchAdministrator': 'Administrátor',
    'Buttons.switchConfusionEnable': 'Povoliť model zmätenia',
    'Buttons.edit': 'Upraviť',
    'Buttons.openInEditor': 'Otvoriť v editore',
    'Buttons.invite': 'Pozvať',
    'Buttons.publish': 'Publikovať',
    'Buttons.clone': 'Klonovať',
    'Buttons.createSegment': 'Vytvoriť segment',
    'Buttons.unassign': 'Zrušiť priradenie',
    'Buttons.update': 'Upraviť',
    'Buttons.createGuide': 'Vytvoriť sprievodcu',
    'Buttons.applyFilters': 'Použiť filtre',
    'Buttons.requestAChange': 'Požiadajte o zmenu',
    'Buttons.cancel.subscription': 'Zrušiť moje predplatné',
    'Buttons.createJourney': 'Vytvoriť trasu',
    'Buttons.clear': 'Vyčistiť',
    'Buttons.install': 'Inštalovať',
    'Buttons.add.timestampRanges': 'Pridajte hodnoty pre filter časových rozsahov',
    'Buttons.generate': 'Generovať',
    'Buttons.audience.resetAllFacts': 'Obnoviť všetky fakty pravidiel',
    'Buttons.audience.resetFactsForUser': 'Obnoviť všetky fakty pravidiel pre používateľa',

    // Date
    'Date.from': 'Dátum od',
    'Date.to': 'Dátum do',

    // Form
    'Form.field.isRequired': 'Toto pole je povinné',
    'Form.field.isLoading': 'Načítavam dáta...',
    'Form.field.isEqualited': 'Položka hesla a položka potvrdenia hesla musí byť rovnaká',
    'Form.field.email': 'Vstup nie je platný E-mail!',
    'Form.field.invalidHost': 'Neplatná doména',
    'Form.passwordRequirementsFail': 'Nevyhovuje požiadavkám na heslo',
    'Form.passwordMustContain': 'Musí obsahovať minimálne',
    'Form.character': 'znak',
    'Form.characters': 'znakov',
    'Form.upperCaseCharacter': 'veľké písmeno',
    'Form.number': 'číslo',
    'Form.passwordInconsistent': 'Zadané heslá sa nezhodujú',

    // Nav items
    'Navigation.applications': 'Priestory',
    'Navigation.accounts': 'Účty',
    'Navigation.dashboard': 'Domov',
    'Navigation.analytics': 'Štatistiky',
    'Navigation.settings': 'Nastavenia',
    'Navigation.guides': 'Sprievodcovia',
    'Navigation.user.profile': 'Profil',
    'Navigation.logout': 'Odhlásiť',
    'Navigation.audit': 'Audit',

    // Applications List
    'Applications.list.empty': 'Pokračujte vytvorením svojho prvého priestoru',

    // Applications menu
    'Applications.navigation.detail.guides': 'Sprievodcovia',
    'Applications.navigation.detail.settings': 'Nastavenia',
    'Applications.navigation.detail.contextHelp': 'Pomocník',
    'Applications.navigation.detail.journeys': 'Trasy',
    'Applications.navigation.detail.segments': 'Segmenty',
    'Applications.navigation.detail.audience': 'Publikum',
    'Applications.navigation.detail.analytics': 'Analytika',
    'Applications.navigation.detail.adopt10.contentCloud': 'Úložisko Obsahu',
    'Applications.navigation.detail.adopt10.splitScreen': 'Rozdelovač Obrazovky',
    'Applications.navigation.detail.adopt10.smartPages': 'Smart Pages',
    'Applications.navigation.detail.adopt10.tooltips': 'Popisy',
    'Applications.navigation.detail.themes': 'Témy',

    // Accounts menu
    'Accounts.navigation.detail.settings': 'Nastavenia',

    // Accounts/Settings menu
    'Accounts.settings.navigation.general': 'Všeobecný',
    'Accounts.settings.navigation.password': 'Heslo',
    'Accounts.settings.navigation.billing': 'Fakturácia',
    'Accounts.settings.createSubscription': 'Vytvoriť členstvo',
    'Accounts.settings.navigation': 'Faktúry',

    // Register user
    'Accounts.register.user': 'Registrácia používateľa',

    // Accounts/Settings/General
    'Accounts.settings.general.userName': 'Používateľské meno',
    'Accounts.settings.general.firstName': 'Meno',
    'Accounts.settings.general.lastName': 'Priezvisko',
    'Accounts.settings.general.createdAt': 'Vytvorené',
    'Accounts.settings.general.label': 'Finwe',
    'Settings.general.id': 'ID',
    'Settings.general.companyid': 'Spoločnosti ID',

    // Accounts/Settings/Billing
    'Accounts.settings.billing.subscription': 'Predplatné',
    'Accounts.settings.billing.currentPlan': 'Aktuálny plán',
    'Accounts.settings.billing.activeUsers': 'aktívnych používateľov za mesiac',
    'Accounts.settings.billing.currentUsage': 'Súčasné použitie',
    'Accounts.settings.billing.billingDetails': 'Fakturačné údaje',
    'Accounts.settings.billing.paymentMethod': 'Spôsob platby',
    'Accounts.settings.billing.nextBillingDate': 'Ďalší dátum fakturácie',
    'Accounts.settings.billing.billingCountry': 'Krajina fakturácie',
    'Accounts.settings.billing.cancelSubscription': 'Potrebujete zrušiť predplatné?',
    'Accounts.settings.billing.cancelSubscription.message': 'Sme smutní, že Vás vidíme ísť.',

    // Account/Settings/Invoices
    'Accounts.settings.invoices': 'Faktúry',
    // Table
    'Accounts.settings.invoices.number': 'Číslo',
    'Accounts.settings.invoices.billingDate': 'Dátum fakturácie',
    'Accounts.settings.invoices.amount': 'Čiastka',
    'Accounts.settings.invoices.status': 'Status',

    // Guides
    'Guides.duplicateGuideWarningTitle': 'Sprievodca obsahuje pravidlá',
    'Guides.duplicateGuideWarningContent':
        'Sprievodca, ktorého chcete duplikovať, obsahuje pravidlá na predchádzajúcich sprievodcov.',
    'Guides.list.empty': 'Pokračujte vytvorením svojho prvého sprievodcu',
    'Guides.list.noResults': 'Nenašli sa žiadny sprievodcovia pre dané vyhľadávanie',
    'Guides.rules': 'Pravidlá',
    'Guides.access': 'Prístup',
    'Guides.general': 'Všeobecné',
    'Guides.pluginConfiguration': 'Konfigurácia plaginu',
    'Guides.message2': 'Skopírujte a vložte tento kód do rozšírení prehliadača',
    'Guides.menuItem.tour': 'Cesta',
    'Guides.journey': 'Trasa',
    'Guides.context': 'Kontext',
    'Guides.menuItem.tour.tooltip':
        'Sprievodca pozostáva zo série krokov vedúcich používateľa cez dôležité body vášho priestoru.',
    'Guides.menuItem.recording': 'Nahrávanie',
    'Guides.menuItem.recording.tooltip':
        'Nahrávanie obsahuje snímky aktuálneho stavu sprievodcov vo forme rôznych výstupov, ako sú dokumenty, animácie alebo videá.',
    'Guides.menuItem.playlist': 'Zoznam dokumentov',
    'Guides.menuItem.playlist.tooltip':
        'Vložte pokyny a podporné materiály, ako sú PDF a videá, do zoznamov skladieb, ku ktorým majú používatelia prístup prostredníctvom kontextového pomocníka.',
    'Guides.menuItem.interaction.collector': 'Interakčný kolektor',
    'Guides.menuItem.interaction.collector.tooltip':
        'Registruje body záujmu vo vašom priestore a následne sleduje interakciu používateľa s nimi, aby bolo možné spustiť budúcu adopciu.',
    'Guides.menuItem.error.collector': 'Error kolektor',
    'Guides.menuItem.error.collector.tooltip':
        'Sleduje chyby v priestore a validačné správy a reportuje ich priestorovému vlastníkovi, aby vykonal akcie na zníženie produkcie chýb.',
    'Guides.menuItem.application.augmentation': 'Popisy',
    'Guides.menuItem.application.augmentation.tooltip':
        'Rozširuje používateľské rozhranie priestoru o dodatočné elementy, ako sú tooltipy, infobubliny alebo obsahové bloky bez nutnosti kontaktovať vaše IT alebo vývojové oddelenie.',
    'Guides.menuItem.publishToEnv': 'Publikovať na iné prostredie',
    'Guides.menuItem.duplicateGuide': 'Duplikovať sprievodcu',
    'Guides.menuItem.createRecording': 'Vytvoriť nahrávku',
    'Guides.menuItem.cancelGuide': 'Zrušiť sprievodcu',
    'Guides.menuItem.recording.download': 'Stiahnuť',
    'Guides.menuItem.recording.generate': 'Generovať',
    'Guides.pluginSetup.button.showConf': 'Ukázať konfiguráciu',
    'Guides.pluginSetup.button.details': 'Detail sprievodcu',
    'Guides.publishToDifferentEnv': 'Publikovať na iné prostredie',
    'Guides.newDomainName': 'Nový názov domény',
    'Guides.oldDomainName': 'Starý názov domény',
    'Guides.selectApplication': 'Zvoľte priestor',
    'Guides.searchPlaceholder': 'Vyhľadajte sprievodcu alebo popis',
    'Guides.editForm.name': 'Názov sprievodcu',
    'Guides.editForm.initialUrl': 'Počiatočná URL webovej stránky',
    'Guides.editForm.description': 'Popis sprievodcu',
    'Guides.editForm.title': 'Upraviť detaily sprievodcu',
    'Guides.contentLanguage': 'Jazyk obsahu',
    'Guides.published': 'Publikované',
    'Guides.unpublished': 'Nepublikované',
    'Guides.startAutomatically': 'Spustite sprievodcu automaticky',
    'Guides.delete.message': 'Naozaj chcete zmazať sprievodcu?',
    'Guides.create.new.guide': 'Vytvoriť sprievodcu ',
    'Guide.credential.set.message': 'V prípade prihlásenia použite nasledujúce nastavenia poverení',
    'Guide.rules.invisible': 'Neviditeľné',
    'Guide.rules.disabled': 'Zakázané',
    'Guide.rules.off': 'Vypnuté',
    'Guide.rules.noRulesAppliedEdit': 'Stlačte pridať pre vytvorenie nového pravidla',
    'Guide.rules.noRulesApplied': 'Žiadne pravidlá nie su aplikované',

    // Journeys
    'Journeys.list.empty': 'Pokračujte vytvorením svojej prvej trasy',
    'Journeys.search.placeholder': 'Vyhľadajte trasu',
    'Journeys.create.journey': 'Vytvoriť trasu',
    'Journeys.edit.journey': 'Upraviť trasu',
    'Journeys.identifier.placeholder': 'Typ identifikátora bez medzier',
    'Journeys.title.placeholder': 'Napíšte ľudský čitateľný názov trasy',
    'Journey.title': 'Nadpis',
    'Journey.confirm.delete.dialog': 'Naozaj chete zmazať túto trasu?',
    'Journey.visible.action.title': 'Akcia po trase je dokončená',
    'Journey.visible.action.options.noAction': 'Žiadna akcia',
    'Journey.visible.action.options.leaveTrackerVisible': 'Nechať stav trasy viditeľný',
    'Journey.afterFinishTour.action.title': 'Akcia po ukončení sprievodcu v trase',
    'Journey.afterFinishTour.action.options.noAction': 'Žiadna akcia',
    'Journey.afterFinishTour.action.options.openContextHelp': 'Otvoriť pomocníka',

    // Context Help
    'ContextHelp.title': 'Pomocník',

    // Context Help/menu
    'ContextHelp.navigation.composition': 'Zloženie',
    'ContextHelp.navigation.settings': 'Nastavenia',

    // Compositon
    'ContextHelp.tour.placeholder': 'Názov sprievodcu',
    'ContextHelp.journey.placeholder': 'Názov trasy',
    'ContextHelp.playlist.placeholder': 'Názov zoznam dokumentov',
    'ContextHelp.expansionPanel.tours': 'Sprievodcovia',
    'ContextHelp.expansionPanel.playlists': 'Zoznam dokumentov',
    'ContextHelp.expansionPanel.journeys': 'Trasy',
    'ContextHelp.expansionPanel.articles': 'Články',
    'ContextHelp.article.source': 'Zdroj článkov',

    // Context Help/Settings
    'ContextHelp.tours': 'Sprievodcovia',
    'ContextHelp.tours.matchUrlText': 'Zahrnúť sprievodcu do pomocníka, pri zhode URL adresy',
    'ContextHelp.tours.matchUrlHelpText':
        'Ak je táto voľba označená, táto príručka bude zahrnutá do pomocníka',
    'ContextHelp.suppressVisibleGuides':
        'Potlačiť viditeľných sprievodcov, ak sa iní naštartujú z pomocníka alebo zoznamu trás',
    'ContextHelp.tours.matchElement': 'Zahrnúť sprievodcu do pomocníka, ak je prvok prítomný',
    'ContextHelp.recommendedTours': 'Odporúčaní sprievodcovia',
    'ContextHelp.listOfRecommendedTours.placeholder': 'Zoznam odporúčaných sprievodcov',
    'ContextHelp.playlists': 'Zoznam dokumentov',
    'ContextHelp.playlists.label': 'Text tlačidla',
    'ContextHelp.playlists.placeholder': 'Zobraziť zoznamy dokumentov',
    'ContextHelp.listHeading': 'Nadpis zoznamu',
    'ContextHelp.listOfTours.placeholder': 'Zoznam sprievodcov',
    'ContextHelp.journeys': 'Trasy',
    'ContextHelp.listOfJourneys.placeholder': 'Zoznam trás',
    'ContextHelp.restartProgressQuestion.placeholder': 'Želáte si reštartovať váš progres?',
    'ContextHelp.progressTracker': 'Priebeh sledovania',
    'ContextHelp.restartQuestion': 'Reštartujte otázku',
    'ContextHelp.confirmRestart': 'Potvrďte reštart',
    'ContextHelp.confirmRestart.placeholder': 'Áno',
    'ContextHelp.declineRestart': 'Zrušiť reštart',
    'ContextHelp.declineRestart.placeholder': 'Nie',
    'ContextHelp.launcher': 'Spúšťač',
    'ContextHelp.position': 'Pozícia',
    'ContextHelp.placeholder': 'Predvolený text',
    'ContextHelp.searchPlaceholder.label': 'Predvolený text pre vyhľadávanie',
    'ContextHelp.searchPlaceholder.placeholder': 'Hľadať',
    'ContextHelp.results': 'Výsledky',
    'ContextHelp.noResultsFound.label': 'Žiadne výsledky',
    'ContextHelp.noResultsFound.placeholder': 'Neboli nájdené žiadne výsledky',
    'ContextHelp.enable.notification': 'Povoliť upozornenie na úspech dokončenej prehliadky',
    'ContextHelp.notification.text': 'Text oznámenia',
    'ContextHelp.notification.text.placeholder':
        'Prehliadku ste úspešne dokončili. Pokračujte ďalej v ceste.',
    'ContextHelp.articles': 'Články',
    'ContextHelp.listOfArticlesHeading.placeholder': 'Zoznam článkov',
    'ContextHelp.learnMoreOfArticle.label': 'Označenie pre celý článok',
    'ContextHelp.learnMoreOfArticle.placeholder': 'Dozvedieť sa viac',
    'ContextHelp.guidanceControl': 'Ovládanie sprievodcov',
    'ContextHelp.guidanceControl.enabled': 'Povoliť ovládanie sprievodcov',
    'ContextHelp.guidanceControl.attachment.title': 'Ovládanie sprievodcov bude zobrazené v',
    'ContextHelp.guidanceControl.attachment.options.contextHelp': 'Pomocník',
    'ContextHelp.guidanceControl.attachment.options.step': 'Krok',
    'ContextHelp.guidanceControl.attachment.options.contextHelpAndStep': 'Pomocník a krok',
    'ContextHelp.guidanceControl.attachment.options.launcher': 'Launcher',
    'ContextHelp.guidanceControl.attachment.options.launcherAndStep': 'Launcher a krok',
    'ContextHelp.guidanceControl.attachment.options.everywhere': 'Všade',
    'ContextHelp.guidanceControl.labelOn': 'Štítok pre zapnuté vedenie',
    'ContextHelp.guidanceControl.labelOn.placeholder': 'Vedenie zapnuté',
    'ContextHelp.guidanceControl.labelOff': 'Štítok pre vypnuté vedenie',
    'ContextHelp.guidanceControl.labelOff.placeholder': 'Vedenie vypnuté',
    'ContextHelp.guidanceControl.persistence.title': 'Trvanie prehliadača',
    'ContextHelp.guidanceControl.persistence.options.browserRestart':
        'Pretrvávať pri reštarte prehliadača',
    'ContextHelp.guidanceControl.persistence.options.currentSession': 'Ponechať iba v aktuálnej relácii',

    // Settings menu
    'Settings.navigation.general': 'Všeobecný',
    'Settings.navigation.integration': 'Integrácia',
    'Settings.navigation.language': 'Jazyk',
    'Settings.navigation.identity': 'Profil',
    'Settings.navigation.multitenancy': 'Viac-klientsky prístup',
    'Settings.navigation.tracking': 'Sledovanie',
    'Settings.navigation.guideDefaults': 'Predvolený sprievodca',
    'Settings.navigation.access': 'Prístup',
    'Settings.navigation.security': 'Zabezpečenia',
    'Settings.navigation.selectorSystem': 'Systém selektorov',
    'Settings.navigation.selectorDefaults': 'Predvolby selektorov',
    'Settings.navigation.confusion': 'Zmätok',
    'Settings.navigation.addOns': 'Doplnky',
    'Settings.navigation.audience': 'Publikum',
    'Settings.navigation.theme': 'Téma',

    // Settings/Integration
    'Settings.integration.title.frameworkSupport': 'Rámcová podpora',
    'Settings.integration.message':
        'Integrovanie programu Adopt je rovnako jednoduché ako vloženie skriptu do šablóny aplikácie. Odporúčame Vám, aby ste integráciu umiestnili na konci pred zatvorením BODY tag',
    'Settings.integration.browserExtension': 'Rozšírenie prehliadača',
    'Settings.integration.message2':
        'Adopt je nástroj na tvorbu obsahu, ktorý Vám umožňuje vytvárať virtuálnych sprievodcov šitých na mieru Vašej applikácie. V štandardnom prípade, keď ste pomocou vyššie uvedených krokov integrovali Adopt, už sa nemusíte báť. Existujú však prípady, keď si chcete vyskúšať možnosti Adopt, nemáte technické skúsenosti a ešte nemáte prostriedky na ich integráciu. V takom prípade nainštalujte rozšírenie Chrome.',
    'Settings.integration.message3':
        'Adopt potrebuje poznať kľúčové informácie o vnútorných komponentoch Vašej applikácie, aby poskytol čo najlepšie integrované skúsenosti. Na základe týchto informácií Vám poskytneme vhodný integračný skript.',
    'Settings.integration.message4':
        'Ak nastavujeme politiku zabezpečenia obsahu vo svojej applikácii, systéme alebo projekte, môžete zahrnúť aj nasledujúcu konfiguráciu',
    'Settings.integration.checkBox.popups': 'Natívne popup okná alebo IFrames',
    'Settings.integration.checkBox.startFromIFrame': 'Spusti z IFrame',
    'Settings.integration.checkBox.enableEditorRedirect': 'Povoliť presmerovanie editora',
    'Settings.integration.radioButton.genericApplication': 'Všeobecný priestor',
    'Settings.integration.radioButton.customScript': 'Vlastný skript',
    'Settings.integration.radioButton.internetExplorer': 'Internet Explorer',
    'Settings.integration.checkBox.ifcNamespace': 'IFC Namespace',

    // Settings/Integration/Experiment without integration
    'Settings.experiment.title': 'Vyskúšajte Adopt bez integrácie',
    'Settings.experiment.message':
        'Adopt Editor je redakčný nástroj, ktorý Vám umožňuje vytvárať virtuálnych sprievodcov prispôsobených Vášmu konkrétnemu priestoru. V prípade, že je Adopt integrovaný štandardnou cestou popísanou vyššie, nie je potrebné vykonávať ďalšie kroky. Ale v prípade, že si želáte vyskúšať schopnosti Adopt, nie ste technicky skúsený a nemáte prostriedky, ako ho ešte zaintegrovať, potom nasledujte inštalačnú procedúru nižšie.',
    'Settings.experiment.guidesList': 'zoznam sprievodcov',
    // Firefox
    'Settings.experiment.firefox.step1.text': 'Nainštalujte FireFox Custom Style Script Add-on',
    'Settings.experiment.firefox.step2':
        'Skopírujte Adopt skript do schránky pomocou tlačidla "KOPÍROVAŤ SKRIPT"',
    'Settings.experiment.firefox.step3a': 'Prejdite na ',
    'Settings.experiment.firefox.step3b': 'vo Vašom priestore',
    'Settings.experiment.firefox.step4':
        'Otvorte sprievodcu v editore kliknutím tlačidlo "OTVORIŤ V EDITORE"',
    'Settings.experiment.firefox.step5a': 'Akonáhle sa editor otvorí v novej záložke, stlačte "js"',
    'Settings.experiment.firefox.step5b':
        'tlačidlo v adresnom riadku prehliadača FireFox na pravej strane',
    'Settings.experiment.firefox.step6': 'Otvorí sa dialógové okno, do ktorého vložíte skript',
    'Settings.experiment.firefox.step7': 'Stlačte "+" tlačidlo v dialógovom okne',
    'Settings.experiment.firefox.step8a':
        'Vložte skript zo schránky do textového poľa s názvom "Javascript code" a odstráňte úvodný ',
    'Settings.experiment.firefox.step8b': 'a aj koncový',
    'Settings.experiment.firefox.step8c': 'element',
    'Settings.experiment.firefox.step9':
        'Zadajte URL adresu, ktorú vidíte v adresnom riadku do poľa "URL Filter" nad textovým poľom "Javascript code"',
    'Settings.experiment.firefox.step10':
        'Znovu načítajte stránku (stlačením tlačidla F5 alebo tlačidla načítaj v prehliadači)',
    'Settings.experiment.firefox.step11':
        'Stránka s editorom sa znovu načíta a Adopt panel nástrojov sa zobrazí',

    // Settings/Language
    'Settings.language.applicationLocalization': 'Lokalizácia priestoru',
    'Settings.language.languages': 'Jazyky',
    'Settings.language.localizationSource': 'Zdroj lokalizácie',
    'Settings.language.message':
        'Adopt podporuje multijazyčné prostredie. V nasledujúcej sekcii zvoľte tie jazyky, v ktorých chcete aby autori obsahu zadávali texty.',
    'Settings.language.message2':
        'Nastavením nasledujúcich informácií o lokalizácii si všimnete Adopt, kde by mal nájsť preferenciu lokalizácie vo Vašom priestore. Je to nastavenie v celom priestore, ktoré môžete využiť v rámci ľubovoľnej príručky, keď chcete prispôsobiť sprievodný jazyk jazyku vašej aplikácie.',
    'Settings.language.translations': 'Preklady',
    'Settings.language.message3.1': 'Použite',
    'Settings.language.message3.2':
        'tak, aby zodpovedal jazykovému vzoru v adrese URL. Jazyk sa identifikuje podľa prvej skupiny zachytenej v zátvorkách. Ukážka: <> / (. *) Sa zhoduje s jazykom "en" z <> / en URL',
    'Settings.language.message4':
        'Ak by ste chceli preložiť obsah vašich krokov v sprievodcoch v kope, toto je cesta. V súčasnosti podporujeme vlastné formáty CSV a MS Excel XLSX, ktoré nezachovávajú formátovanie HTML. Majte to na pamäti pri opätovnom importovaní.',
    'Settings.language.withPath': 's cestou',
    'Settings.language.label': 'Zadajte jazyk, ktorý chcete podporiť',
    'Settings.language.label2': 'Lokalizácia je identifikovaná z',
    'Settings.language.label3': 'Cesta',
    'Settings.language.readFrom': 'Načítať jazyk z',
    'Settings.language.readFromBrowser': 'prehliadavača',
    'Settings.language.readFromApplicationSettings': 'nastavení priestoru',
    'Settings.language.fallback': 'Predvolený jazyk',
    // Menu
    'Settings.language.menu.adopt': 'Adopt',
    'Settings.language.menu.adopt.excel': 'Adopt Excel',
    'Settings.language.menu.adopt.csv': 'Adopt CSV',

    // Settings/General
    'Settings.accessDenied': 'Prístup zamietnutý',
    'Settings.errorGetRolloutPoliciesByMyOrganizations':
        'Nastala chyba pri získavaní rollout policies podľa organizácií',
    'Settings.errorGetRolloutPoliciesBySpaceId':
        'Nastala chyba pri získavaní rollout policies podľa priestoru',
    'Settings.general.applicationDetail': 'Detail priestoru',
    'Settings.general.name': 'Meno',
    'Settings.general.domains': 'Domény rozšírenia',
    'Settings.general.extensionUrls.options.notSet': '(Nenastavené)',
    'Settings.general.rolloutPolicy': 'Rollout Policy',
    'Settings.general.inaccessible': 'Neprístupné',
    'Settings.general.trustedDomains': 'Dôveryhodné domény',
    'Settings.general.extensionUrls.message':
        '* Aktualizácia domén rozšírenia môže trvať zopár minút na to aby mala efekt.',
    'Settings.general.trustedDomains.message':
        '* Aktualizácia dôveryhodných dómen môže trvať zopár minút na to aby mala efekt.',
    'Settings.general.avatar': 'Avatar',
    'Settings.general.upload': 'Nahrať',
    'Settings.general.message':
        'Radi by sme vás upozornili skôr, ako podniknete túto akciu. Po odstránení aplikácie budú odstránené aj všetky jej príručky, segmenty, fakty a súvisiace údaje.',
    'Settings.general.label': 'Adopt',
    'Settings.general.label2': 'Zadajte regex výraz pre URL, ktorá sa má načítať pre tento priestor',
    'Settings.general.label3': 'Zadajte dôveryhodnú doménu',
    'Settings.general.label4': 'Musí obsahovať správny formát domény',
    'Settings.general.duplicateApplication': 'Naklonovať priestor',
    'Settings.general.duplicateApplication.message':
        'Stlačením tlačidla Vykonať sa duplikuje priestor so všetkými nastaveniami a sprievodcami',

    // Settings/Access
    'Settings.access.userAccess': 'Prístup užívateľa',
    'Settings.access.message': 'Tu je miesto, kde udelíte administrátorom prístup k tomuto priestoru.',
    'Settings.access.owner': 'Majiteľ',
    'Settings.access.users': 'Užívatelia',
    'Settings.access.label': 'Nápoveda',
    'Settings.access.emptyList': 'Zoznam je prázdny',
    'Settings.access.label2': 'Čítať',
    'Settings.access.inviteUsers': 'Pozvať nových používateľov',
    'Settings.access.message2':
        'Tu môžete pozvať nových používateľov na účasť v priestore. Títo používatelia ešte nemajú účet Adopt, a preto musia byť zaregistrovaní. Neváhajte napísať e-mail ďalších prispievateľov a pozvať ich.',
    'Settings.access.invite.placeholder': 'E-mail prispievateľa',
    'Settings.access.presets': 'Prednastavenia',

    // Settings/Identity
    'Settings.identity.identityAndUserProfile': 'Profil používateľa',
    'Settings.identity.message':
        'Nastavením nasledujúcich informácií o profile si všimnete Adopt, kde by mal nájsť identifikátor používateľa a priradenie rolí vo Vašom priestore. Je to nastavenie v celom priestore, ktoré môžete použiť v rámci ľubovoľnej príručky, keď sa chcete rozhodnúť pre ktorého používateľa alebo ktorou rolu by mala byť sprievodca viditeľný.',
    'Settings.identity.label': 'Prihlásení užívatelia sú identifikovaní podľa',
    'Settings.identity.label2': 'Úloha používateľa sa identifikuje pomocou',
    'Settings.identity.label3': 'Cesta',
    'Settings.identity.helperText': '*(Súbory cookie so zapnutým Http Only parametrom nebudú fungovať)',

    // Settings/Multitenancy
    'Settings.multitenancy.multiTenancy': 'Viac-klientsky prístup',
    'Settings.multitenancy.message':
        'Ak máte priestor s viac-klientskym prístupom, a ak chcete používať rovnakých sprievodcov vo viacerých doménach ako napríklad nájomca - doména - doména.com a nájomník - domáci dom - doména.com, môžete určiť vzor, ktorý zodpovedá rozlišovaciu časť URL tu. Nastavenie správneho vzoru šetrí Váš čas, pretože pre každú doménu nemusíte vytvárať samostatných sprievodcov. Práve vytvárate sprievodcov pre jedného nájomcu a my sa postaráme o zvyšok.',
    'Settings.multitenancy.label': 'Šablóna',

    // Settings/Selector system
    'Settings.selectorSystem.title': 'Selektor elementu',
    'Settings.selectorSystem.message':
        'Systém selektorov umožňuje ovplyvniť ako Adopt chápe internú zobrazovaciu štruktúru Vášho priestoru (pre technických ľudí - DOM strom). Z toho dôvodu potrebujeme pre určité prípady daľšie inštrukcie, ktorými zabezpečíme dlhodobo udržateľný onboarding',
    'Settings.selectorSystem.label': 'Šablóna',
    'Settings.selectorSystem.label2': 'Nahrádzač',
    'Settings.selectorSystem.classOnly.title': "Selektor typu 'iba triedy'",
    'Settings.selectorSystem.classOnly.message': 'Tento selektor pozostáva iba z mien CSS tried',
    'Settings.selectorSystem.message.1':
        'Selektory elementu sú zodpovedné za jedinečné nájdenie elementov priestoru. Adopt zapisuje viacero typov selektorov, aby zvýšil šancu nájsť želaný element.',
    'Settings.selectorSystem.message.2':
        'Adopt detekuje dynamicky generované identifikátory a dokáže s nimi správne narábať. V nasledujúcom príklade aplikačný rámec Angular dynamicky generuje mená tried pre konkrétny element, napr. <div class="ng-123"/>, <div class="ng-345"/>, ... Ale my vieme ísť ešte ďalej, zoberieme všetky prefixované triedy ako <b>ng-</b> alebo <b>col-</b> a správne ošetríme pomocou konfigurácie:',
    'Settings.selectorSystem.message.3': 'Šablóna = (.+?)(?:[-].*)',
    'Settings.selectorSystem.message.4': 'Nahrádzač = [class*=$1]',
    'Settings.selectorSystem.classNameBlacklist.title': 'Ignorované triedy prvkov',
    'Settings.selectorSystem.idBlacklist.title': 'Ignorované identifikátory prvkov',
    'Settings.selectorSystem.attributes.placeholder': 'Ignorované atributy',
    'Settings.selectorSystem.classNameBlacklist.message':
        'Nasleduje zoznam čiarkou oddelených mien tried elementov, ktoré majú byť vylúčené pri zostavovaní selektorov.',
    'Settings.selectorSystem.classNameBlacklist.placeholder': 'Čiarkou oddelený zoznam tried',
    'Settings.selectorSystem.idBlacklist.message':
        'Nasleduje zoznam čiarkou oddelených identifikátorov elementov, ktoré majú byť vylúčené pri zostavovaní selektorov.',
    'Settings.selectorSystem.idBlacklist.placeholder': 'Čiarkou oddelený zoznam identifikátorov',
    'Settings.selectorSystem.customWhitelist.title': 'Yahrnuté názvy atribútov prvkov',
    'Settings.selectorSystem.customWhitelist.message':
        'Nasleduje zoznam čiarkou oddelených názvov atribútov elementov, ktoré majú byť yahrnuté pri zostavovaní selektorov.',
    'Settings.selectorSystem.customWhitelist.placeholder': 'Čiarkou oddelený zoznam názvov atribútov',
    'Settings.selectorSystem.excludedLocations.placeholder': 'CSS selektor',
    'Settings.selectorSystem.excludedLocations.title': 'Selektor pre rozbaľovacie zoznamz',

    // Settings/Selector defaults
    'Settings.selectorDefaults.title': 'Predvolby selekcie elementov',
    'Settings.selectorDefaults.message':
        'Tu môžete nastaviť, ktoré lokalizátory chcete nastaviť ako predvolene <strong>zakázané</strong> pri vytváraní selektorov. Pre <strong>zakázanie</strong>, zaškrtnite povinné selektory zo zoznamu nižšie. Zmeny sa prejavie iba v novovytvorených sprievodcovch. Predvolené nastavenia budú aplikované na všetkých miestach, na ktorých je možné selektovať element.',

    // Settings/Tracking
    'Settings.tracking.userBehaviour': 'Sledovanie správania používateľa',
    'Settings.tracking.experimental': 'experimentálne',
    'Settings.tracking.message':
        'Ak chcete povoliť sledovanie experimentálneho správania, ktoré sa používa na generovanie usmernení a analýzu zmätku používateľov, kliknite na tlačidlo Povoliť a vyberte možnosti sledovania. Pre udalosti "keyup" a "keydown" nemôžeme sledovať stlačené tlačidlo.',
    'Settings.tracking.message2':
        'Predvolené hodnoty vzorkovacej frekvencie sú 16 (~ 60 snímok za sekundu) a dávkový interval je 1000 (ms). Nastavte plán, ktorý bude sledovať iba správanie používateľa v požadovanom časovom intervale. Formát rozvrhu je začiatočný, kde začiatok a koniec sú hodiny (tj časový rozvrh 10-14 sleduje aktivitu používateľov medzi 10: 00-14: 00)',
    'Settings.tracking.events': 'Sledované udalosti',
    'Settings.tracking.label': 'Snímacia frekvencia',
    'Settings.tracking.label2': 'Interval odosielania dávky (milisekundy)',
    'Settings.tracking.label3': 'Plán (začiatok-koniec)',
    'Settings.tracking.event.click': 'kliknutie',
    'Settings.tracking.event.mousemove': 'pohyb myši',
    'Settings.tracking.event.scroll': 'rolovanie',
    'Settings.tracking.event.mousedown': 'myš nadol',
    'Settings.tracking.event.mouseup': 'myš nahor',
    'Settings.tracking.event.keydown': 'klávesa nadol',
    'Settings.tracking.event.keyup': 'klávesa nahor',
    'Settings.tracking.whitelist': 'Zoznam povolených adries URL',
    'Settings.tracking.label4': 'Šablóna',

    // Settings/Confusion
    'Settings.confusion.title': 'Predpovedajte zmätenosť používateľov',
    'Settings.confusion.label': 'Typ modelu',
    'Settings.confusion.modelId.label': 'Model ID',
    'Settings.confusion.modelUrls.placeholder': 'URLs',
    'Settings.confusion.confusionTimeoutSeconds': 'Oneskorenie medzi detekciami (sekundy)',
    'Settings.confusion.reaction.label': 'Reakcia na zmätenie',
    'Settings.confusion.reaction.openConfusionDialog': 'Otvorenie pomocného dialógu',
    'Settings.confusion.reaction.shakeContextHelp': 'Zatrasenie ikonou pomocníka',
    'Settings.confusion.reaction.none': 'Žiadna',
    'Settings.confusion.reaction.numberOfShakes': 'Počet zatrasení',
    // Generate guide
    'Settings.confusion.guideGeneration.title':
        'Generovanie sprievodcu na základe správania používateľov',
    'Settings.confusion.guideGeneration.idType.label': 'Typ ID',
    'Settings.confusion.guideGeneration.ids.floatingLabelText': 'ID hodnota',
    'Settings.confusion.guideGeneration.urls.floatingLabelText': 'URL hodnota',
    'Settings.confusion.guideGeneration.minNumOfExperts.floatingLabelText': 'Minimálna podpora expertov',
    'Settings.confusion.guideGeneration.maxNumOfGuides.floatingLabelText': 'Maximálny počet sprievodcov',
    'Settings.confusion.guideGeneration.modelType.label': 'Typ modelu',
    'Settings.confusion.guideGeneration.preset.label': 'Preset',
    'Settings.confusion.guideGeneration.preset.customValues': 'Vlastné hodnoty',
    'Settings.confusion.guideGeneration.preset.daySplit': 'Rozdelenie po dni',
    'Settings.confusion.guideGeneration.preset.breakSplit': 'Rozdelenie po prestávky v aktivite',
    'Settings.confusion.guideGeneration.preset.sequenceSplit': 'Rozdelenie po sekvenciách',
    'Settings.confusion.guideGeneration.sequenceMiner.label': 'Stratégia rozdelenia na sekvencie',
    'Settings.confusion.guideGeneration.maxStepsInSequence.floatingLabelText':
        'Maximálny počet elementov používateľov interakcie',
    'Settings.confusion.guideGeneration.timeThreshold.floatingLabelText':
        'Maximálny čas medzi interakciami v sekvencii"',
    'Settings.confusion.guideGeneration.EGGv3Control':
        'Pozor: Vybratý typ modelu vyžaduje EGG rozšírenie!',

    // Settings/Guide defaults
    'Settings.defaults.guideDefaults': 'Predvolené nastavenia sprievodcov',
    'Settings.defaults.message':
        'Tu môžete nastaviť predvolené hodnoty pre kroky vo vašich sprievodcoch. Zmeny sa prejavia iba v novozaložených sprievodcoch.',
    'Settings.defaults.nodeDefaults': 'Predvolené nastavenia prekrytia',
    'Settings.defaults.navigate': 'Ak sa zobrazí krok, prejdite na adresu URL',
    'Settings.defaults.ignoreNavigation': 'Ignorovať adresu URL',
    'Settings.defaults.ignoreQueryParameters': 'Ignorovať zaznamenané parametre dopytu',
    'Settings.defaults.scrollToStep': 'Posúvajte pre obrazenie prvku',
    'Settings.defaults.notCovered': 'Zobrazte krok, keď prvok nie je prekrytý',
    'Settings.defaults.pathDefinition': 'Nastavenie definície trasy prvku',
    'Settings.defaults.updateOnScroll': 'Umožňuje prepočítať pozíciu, keď používateľ posúva',
    'Settings.defaults.label': 'Posúvanie umiestnenia kontajnera',

    // Settings/Theme
    'Settings.theme.titlePage': 'Téma priestoru',
    'Settings.theme.message':
        'Téma priestoru bude implementovaná pre časti Adopt, ako sú context help, journey tracker alebo progress tracker. V prípade sprievodcu je možné tému v Adopt editore nastaviť aj samostatne.',
    'Settings.theme.applicationTheme': 'Zvolená téma priestoru',
    'Settings.theme.themeVariant.title': 'Varianty tém',
    'Settings.theme.themeVariant.message':
        'Základný systém môže dynamicky meniť svoj vzhľad a dojem, či už ide o svetlý alebo tmavý variant. Adopt by si mal byť tejto zmeny vedomý a reagovať s upravenou témou, aby skúsenosti používateľov boli skvelé. Preto musíte dať Adopt-ovi pokyn, kde nájsť informácie o type variantu témy.',
    'Settings.theme.variantEnabled': 'Varianty povolené',
    'Settings.theme.variantIdentifiedBy': 'Varianta je identifikovaná podľa',
    'Settings.theme.withPath': 's cestou',
    'Settings.theme.withPath.placeholder': 'Nápoveda text',
    'Settings.theme.fallbackVariantValue': 'Hodnota záložného variantu',
    'Settings.theme.fallbackVariantValue.placeholder':
        'Uveďte názov variantu témy, ktorý sa používa ako záložný',
    'Settings.theme.options.localStorage': 'Local Storage',
    'Settings.theme.options.notSet': '(Nie je nastavené)',
    'Settings.theme.options.cookie': 'Cookie',
    'Settings.theme.options.jsVariable': 'Javascript Value',
    'Settings.theme.options.cssPath': 'CSS Selektor',
    'Settings.theme.options.urlQuery': 'URL Query',

    // Settings/Add-ons
    'Settings.addOns.title': 'Aktívne doplnky',
    'Settings.addOns.message':
        'Tu je miesto, kde aktivujete doplnky Adopt pre priestor. Doplnky rozširujú funkčnosť základnej platformy Adopt o systémy tretích strán.',
    'Settings.addOns.input.placeholder': 'Vyhľadajte doplnok',
    'Settings.addOns.input.label': 'Doplnky, ktoré sú k dispozícii',
    // Add-on detail
    'Settings.addOn.detail.title': 'Detail doplnku',
    'Settings.addOn.detail.vendor': 'Predajca',
    'Settings.addOn.detail.systemKey': 'Systémový kľúč',
    'Settings.addOn.detail.description': 'Popis',
    'Settings.addOn.detail.description.placeholder': 'Integrácia služby Segment.com do Adopt...',
    'Settings.addOn.detail.expansionPanel.configuration': 'Adopt Konfigurácia',
    'Settings.addOn.detail.authentication': 'Overenie pravosti',
    'Settings.addOn.detail.username': 'Užívateľské meno',
    'Settings.addOn.detail.password': 'Heslo',
    'Settings.addOn.detail.clientID': 'ID klienta',
    'Settings.addOn.detail.clientSecret': 'Tajomstvo klienta',
    'Settings.addOn.detail.apiKey': 'Api kľúč',
    'Settings.addOn.detail.expansionPanel.addOnSpecificConfiguration': 'Konfigurácia doplnku',

    // Settings/Audience
    'Settings.audience.resetAll.title': 'Obnovte všetky fakty pravidiel',
    'Settings.audience.resetAll.message':
        'Kliknutím na tlačidlo môžete obnoviť všetky fakty v priestore.',
    'Settings.audience.confirmDialog': 'Naozaj si želáte obnoviť všetky fakty zvoleného priestoru?',
    'Settings.audience.resetFactsForUser.title': 'Obnovte všetky fakty pravidiel pre používateľa',
    'Settings.audience.resetFactsForUser.message':
        'Kliknutím na tlačidlo môžete obnoviť všetky fakty pre konkrétneho používateľa',
    'Settings.audience.resetFactsForUser.form': 'Zadajte ID používateľa na odstránenie skutočností:',

    // Audit
    'Audit.title': 'Audit log',
    'Audit.table.time': 'Čas',
    'Audit.table.event': 'Typ udalosti',
    'Audit.table.userName': 'Meno užívateľa',
    'Audit.table.ipAddress': 'IP adresa',
    'Audit.table.result': 'Výsledok',
    'Audit.fail.loadData': 'Nepodarilo sa uložiť Vaše dáta, niečo sa pokazilo',

    // Accounts
    'Accounts.title': 'Účty',

    // Invite section
    'Applications.createNewApp.invite': 'Pozvať',
    'Applications.createNewApp.message':
        'Tu môžete pozvať nových používateľov na účasť v priestore. Títo používatelia ešte nemajú účet Adopt, a preto musia byť zaregistrovaní. Neváhajte napísať e-mail ďalších prispievateľov a pozvať ich.',
    'Application.createNewApp.placeholder': 'E-mail prispievateľa',

    // Segments
    'Segments.createSegmentTitle': 'Vytvoriť segment',
    'Segments.editSegmentTitle': 'Upraviť segment',
    'Segments.search.placeholder': 'Vyhľadajte segment',
    'Segments.createSegment.kind': 'Druh',
    'Segments.createSegment.valueType': 'Typ hodnoty',
    'Segments.createSegment.name': 'Názov',
    'Segments.createSegment.systemKey': 'Systémový kľúč',
    'Segments.createSegment.description': 'Popis',
    'Settings.createSegment.placeholder': 'Nápoveda',
    'Settings.createSegment.message1':
        'Užívateľský segment je uložený v analytickej databáze. Je zdieľaný v celej organizácii.',
    'Settings.createSegment.message2':
        'Segment User Frontend je dostupný iba v rozhraní priestoru a nie je uložený v databáze Analytics. Hodnota segmentu sa vyhodnocuje v cieľovom priestore.',
    'Settings.createSegment.message3':
        'Adopt je schopný zbierať segment System Collected. Ak ho vyberiete, bude aktivovaný v priestore a uložený v databáze Analytics.',

    // Themes
    'Themes.title': 'Témy',
    'Themes.search.placeholder': 'Vyhľadajte tému',

    // Theme Form
    'Themes.edit.title': 'Upraviť tému',
    'Theme.edit.name': 'Názov',
    'Theme.edit.name.placeholder': 'Klon Modern Inverted témy',
    'Theme.edit.background': 'Pozadie',
    'Theme.edit.primaryColour': 'Primárna farba',
    'Theme.edit.secondaryColour': 'Sekundárna farba',
    'Theme.edit.imageAddress': 'Image address',
    'Theme.edit.font': 'Písmo',
    'Theme.edit.fontFamily': 'Font family',
    'Theme.edit.fontColour': 'Farba písma',
    'Theme.edit.titleColour': 'Farba nadpisu',
    'Theme.edit.step': 'Krok',
    'Theme.edit.depth': 'Hĺbka',
    'Theme.edit.navigation': 'Navigácia',
    'Theme.edit.navigation.primaryColour': 'Primárna farba',
    'Theme.edit.navigation.secondaryColour': 'Sekundárna farba',
    'Theme.edit.shadow': 'tieň',
    'Theme.edit.colour': 'Farba',
    'Theme.edit.shadow.depth': 'Hĺbka',
    'Theme.delete.message': 'Naozaj chcete zmazať tému?',
    'Theme.edit.error': 'Nastala systémová chyba.',

    // AccountNotifications
    'AccountNotifications.title': 'Oznámenia',
    // Table
    'AccountNotification.timestamp': 'Časová značka',
    'AccountNotification.subject': 'Objekt',
    'AccountNotification.message': 'Správa',
    'AccountNotification.type': 'Typ',

    // Tables
    'Tables.performance.guideName': 'Názov sprievodcu',
    'Tables.performance.visitorsStarted': 'Návštevníkov začalo',
    'Tables.performance.visitorsFinished': 'Návštevníkov dokončilo',
    'Tables.performance.usersStarted': 'Užívateľov začalo',
    'Tables.performance.usersFinished': 'Užívateľov dokončilo',

    'Tables.funnel.guideName': 'Sprievodca',
    'Tables.funnel.state': 'Stav',
    'Tables.funnel.absolute': 'Absolútne',
    'Tables.funnel.relative': 'Relatívne',

    'Tables.triggers.guideName': 'Názov sprievodcu',
    'Tables.triggers.stepName': 'Názov kroku',
    'Tables.triggers.triggerName': 'Názov spúšťača',
    'Tables.triggers.count': 'Počet',

    'Tables.accounts.userName': 'Užívateľské meno',
    'Tables.accounts.fistName': 'Meno',
    'Tables.accounts.lastName': 'Priezvisko',
    'Tables.accounts.email': 'Email',
    'Tables.accounts.verified': 'Overenie',
};
